<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.2812 11.2812C11.2812 11.7127 10.9315 12.0625 10.5 12.0625C10.0685 12.0625 9.71875 11.7127 9.71875 11.2812C9.71875 10.8498 10.0685 10.5 10.5 10.5C10.9315 10.5 11.2812 10.8498 11.2812 11.2812Z"
                :fill="color" 
            />
            <path
                d="M5.8125 14.4062C6.24397 14.4062 6.59375 14.0565 6.59375 13.625C6.59375 13.1935 6.24397 12.8438 5.8125 12.8438C5.38103 12.8438 5.03125 13.1935 5.03125 13.625C5.03125 14.0565 5.38103 14.4062 5.8125 14.4062Z"
                :fill="color" 
            />
            <path
                d="M6.59375 15.9688C6.59375 16.4002 6.24397 16.75 5.8125 16.75C5.38103 16.75 5.03125 16.4002 5.03125 15.9688C5.03125 15.5373 5.38103 15.1875 5.8125 15.1875C6.24397 15.1875 6.59375 15.5373 6.59375 15.9688Z"
                :fill="color" 
            />
            <path
                d="M8.15625 14.4062C8.58772 14.4062 8.9375 14.0565 8.9375 13.625C8.9375 13.1935 8.58772 12.8438 8.15625 12.8438C7.72478 12.8438 7.375 13.1935 7.375 13.625C7.375 14.0565 7.72478 14.4062 8.15625 14.4062Z"
                :fill="color" 
            />
            <path
                d="M8.9375 15.9688C8.9375 16.4002 8.58772 16.75 8.15625 16.75C7.72478 16.75 7.375 16.4002 7.375 15.9688C7.375 15.5373 7.72478 15.1875 8.15625 15.1875C8.58772 15.1875 8.9375 15.5373 8.9375 15.9688Z"
                :fill="color" 
            />
            <path
                d="M10.5 14.4062C10.9315 14.4062 11.2812 14.0565 11.2812 13.625C11.2812 13.1935 10.9315 12.8438 10.5 12.8438C10.0685 12.8438 9.71875 13.1935 9.71875 13.625C9.71875 14.0565 10.0685 14.4062 10.5 14.4062Z"
                :fill="color" 
            />
            <path
                d="M11.2812 15.9688C11.2812 16.4002 10.9315 16.75 10.5 16.75C10.0685 16.75 9.71875 16.4002 9.71875 15.9688C9.71875 15.5373 10.0685 15.1875 10.5 15.1875C10.9315 15.1875 11.2812 15.5373 11.2812 15.9688Z"
                :fill="color" 
            />
            <path
                d="M12.8438 14.4062C13.2752 14.4062 13.625 14.0565 13.625 13.625C13.625 13.1935 13.2752 12.8438 12.8438 12.8438C12.4123 12.8438 12.0625 13.1935 12.0625 13.625C12.0625 14.0565 12.4123 14.4062 12.8438 14.4062Z"
                :fill="color" 
            />
            <path
                d="M13.625 15.9688C13.625 16.4002 13.2752 16.75 12.8438 16.75C12.4123 16.75 12.0625 16.4002 12.0625 15.9688C12.0625 15.5373 12.4123 15.1875 12.8438 15.1875C13.2752 15.1875 13.625 15.5373 13.625 15.9688Z"
                :fill="color" 
            />
            <path
                d="M15.1875 14.4062C15.619 14.4062 15.9688 14.0565 15.9688 13.625C15.9688 13.1935 15.619 12.8438 15.1875 12.8438C14.756 12.8438 14.4062 13.1935 14.4062 13.625C14.4062 14.0565 14.756 14.4062 15.1875 14.4062Z"
                :fill="color" 
            />
            <path
                d="M13.625 11.2812C13.625 11.7127 13.2752 12.0625 12.8438 12.0625C12.4123 12.0625 12.0625 11.7127 12.0625 11.2812C12.0625 10.8498 12.4123 10.5 12.8438 10.5C13.2752 10.5 13.625 10.8498 13.625 11.2812Z"
                :fill="color" 
            />
            <path
                d="M15.1875 12.0625C15.619 12.0625 15.9688 11.7127 15.9688 11.2812C15.9688 10.8498 15.619 10.5 15.1875 10.5C14.756 10.5 14.4062 10.8498 14.4062 11.2812C14.4062 11.7127 14.756 12.0625 15.1875 12.0625Z"
                :fill="color" 
            />
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5.03125 0.34375C5.46272 0.34375 5.8125 0.693528 5.8125 1.125V2.6875H15.1875V1.125C15.1875 0.693528 15.5373 0.34375 15.9688 0.34375C16.4002 0.34375 16.75 0.693528 16.75 1.125V2.6875H17.5312C19.2571 2.6875 20.6562 4.08661 20.6562 5.8125V17.5312C20.6562 19.2571 19.2571 20.6562 17.5312 20.6562H3.46875C1.74286 20.6562 0.34375 19.2571 0.34375 17.5312V5.8125C0.34375 4.08661 1.74286 2.6875 3.46875 2.6875H4.25V1.125C4.25 0.693528 4.59978 0.34375 5.03125 0.34375ZM19.0938 9.71875C19.0938 8.85581 18.3942 8.15625 17.5312 8.15625H3.46875C2.60581 8.15625 1.90625 8.85581 1.90625 9.71875V17.5312C1.90625 18.3942 2.60581 19.0938 3.46875 19.0938H17.5312C18.3942 19.0938 19.0938 18.3942 19.0938 17.5312V9.71875Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgEvents',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>